module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/logoPink-61602580426f107513fe70da60f43ca3.png";